<template>
  <KvTooltip v-if="tooltip" :text="tooltip" placement="top">
    <KvChip :color="badge.color" density="extra-compact">
      {{ badge.label }}
    </KvChip>
  </KvTooltip>
  <KvChip v-else :color="badge.color" density="extra-compact">
    {{ badge.label }}
  </KvChip>
</template>

<script>
import KvChip from '@/components/ui/kv-chip.vue';
import KvTooltip from '@/components/ui/kv-tooltip.vue';

export default {
  name: 'NotificationStatusBadge',
  components: { KvChip, KvTooltip },
  props: {
    status: { type: String, default: null },
    failReason: { type: String, default: null },
    deliveredAt: { type: String, default: null },
    readAt: { type: String, default: null },
    repliedAt: { type: String, default: null },
  },
  computed: {
    badge() {
      switch (this.status) {
        case 'failed':
          return { label: 'Falha no envio', color: 'error' };
        case 'scheduled':
          return { label: 'Agendado', color: 'default' };
        case 'queued':
          return { label: 'Processando', color: 'default' };
        case 'accepted':
          return { label: 'Aceito', color: 'warning' };
        case 'sent':
          if (this.repliedAt) return { label: 'Respondida', color: 'primary' };
          if (this.readAt) return { label: 'Lida', color: 'success' };
          if (this.deliveredAt) return { label: 'Entregue', color: 'success' };
          return { label: 'Enviado', color: 'success' };
        default:
          return { label: 'Pendente', color: 'default' };
      }
    },
    tooltip() {
      if (this.status !== 'failed' || !this.failReason) return null;
      return this.failReason;
    },
  },
};
</script>
